module.exports = __webpack_public_path__ + "static/media/ellipsis.109bb093.svg";